{
  "语言": "Language",
  "请输入邮箱": "Enter your email address",
  "请输入排序值": "Enter the sort order",
  "例如：{{value}}": "e.g. {{value}}",
  "切换语言会刷新页面，请先保存修改": "Changing language reloads the page. Save your changes first.",
  "无法保存语言设置": "Unable to save language preference",
  "未登录": "Not signed in",
  "确认退出登录？": "Sign out?",
  "退出后需重新登录才能继续使用。": "You will need to sign in again to continue.",
  "退出登录": "Sign out",
  "取消": "Cancel",
  "个人中心": "My account",
  "跳到主要内容": "Skip to main content",
  "切换到浅色": "Switch to light mode",
  "切换到深色": "Switch to dark mode",
  "切换主题": "Switch theme",
  "重试菜单": "Reload menu",
  "连接全球商机，助力企业出海": "Connecting businesses to global opportunities",
  "我已阅读并同意": "I have read and agree to",
  "我已阅读并同意用户协议和隐私条款": "I have read and agree to the User Agreement and Privacy Notice",
  "请先阅读并同意用户协议和隐私条款": "Please read and agree to the User Agreement and Privacy Notice first",
  "暂无数据": "No data",
  "重试": "Retry",
  "正在加载": "Loading",
  "趋势": "Trend",
  "Nest 管理后台": "Nest Admin",
  "无法连接服务器，请确认后端已启动、代理配置正确": "Cannot connect to the server. Check the backend and proxy configuration.",
  "请求失败（HTTP {{status}}）": "Request failed (HTTP {{status}})",
  "服务器返回格式异常": "Invalid server response",
  "请求超时，请稍后重试": "Request timed out. Please try again later.",
  "请求超时，操作结果尚未确认，请刷新后核对": "Request timed out. Refresh to check whether the operation completed.",
  "{{message}}（{{fields}}）": "{{message}} ({{fields}})",
  "发生未知错误": "An unknown error occurred",
  "{{days}} 天 {{hours}} 小时": "{{days}}d {{hours}}h",
  "{{hours}} 小时 {{minutes}} 分": "{{hours}}h {{minutes}}m",
  "{{minutes}} 分 {{seconds}} 秒": "{{minutes}}m {{seconds}}s",
  "{{seconds}} 秒": "{{seconds}}s",
  "品牌蓝": "Brand blue",
  "黑白灰": "Monochrome",
  "拂晓蓝": "Daybreak blue",
  "极客蓝": "Geek blue",
  "酱紫": "Purple",
  "薄暮红": "Dust red",
  "火山橙": "Volcano orange",
  "明青": "Cyan",
  "极光绿": "Polar green",
  "日暮黄": "Sunrise yellow",
  "侧边菜单": "Side menu",
  "顶部菜单": "Top menu",
  "混合菜单": "Mixed menu",
  "提交时 IP 属地": "IP location at submission",
  "注册时 IP 属地": "IP location at registration",
  "当前网络所在地": "Current network location",
  "属地记录时间": "Location recorded at",
  "平台代发": "Published by platform",
  "未记录": "Not recorded",
  "暂无法识别": "Location unavailable",
  "识别中": "Detecting location",
  "与企业所在地不同，待核实": "Differs from company location; review needed",
  "根据提交时的网络地址识别，仅供参考。": "Estimated from the network address at submission; for reference only.",
  "提交时记录国家及省级区域，并随信息公开展示，仅供参考。": "Country and region are recorded at submission and displayed with the listing, for reference only.",
  "注册时记录国家及省级区域，仅供本人和平台审核查看。": "Country and region are recorded at registration, visible only to you and authorized reviewers.",
  "北京市": "Beijing",
  "天津市": "Tianjin",
  "上海市": "Shanghai",
  "重庆市": "Chongqing",
  "河北省": "Hebei",
  "山西省": "Shanxi",
  "辽宁省": "Liaoning",
  "吉林省": "Jilin",
  "黑龙江省": "Heilongjiang",
  "江苏省": "Jiangsu",
  "浙江省": "Zhejiang",
  "安徽省": "Anhui",
  "福建省": "Fujian",
  "江西省": "Jiangxi",
  "山东省": "Shandong",
  "河南省": "Henan",
  "湖北省": "Hubei",
  "湖南省": "Hunan",
  "广东省": "Guangdong",
  "海南省": "Hainan",
  "四川省": "Sichuan",
  "贵州省": "Guizhou",
  "云南省": "Yunnan",
  "陕西省": "Shaanxi",
  "甘肃省": "Gansu",
  "青海省": "Qinghai",
  "台湾省": "Taiwan",
  "内蒙古自治区": "Inner Mongolia",
  "广西壮族自治区": "Guangxi",
  "西藏自治区": "Tibet",
  "宁夏回族自治区": "Ningxia",
  "新疆维吾尔自治区": "Xinjiang",
  "香港特别行政区": "Hong Kong",
  "澳门特别行政区": "Macao"
}
